module.exports = __webpack_public_path__ + "img/upload.0ad6a8e7.png";